<template>
    <div :class="[{'downloadIconContainer': !listItem}]">
        <div v-if="$vuetify.breakpoint.smAndUp && !listItem">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-if="!btnText" icon
                           @click="exportToExcel()">
                        <v-icon v-on="on" v-bind="attrs" class="ma-3">
                            mdi-download
                        </v-icon>
                    </v-btn>
                    <v-btn v-else @click="exportToExcel()">
                        {{btnText}}
                    </v-btn>
                </template>
                <span>Download nach Excel</span>
            </v-tooltip>
        </div>
        <v-list-item v-if="$vuetify.breakpoint.smAndUp && listItem"
                     @click="exportToExcel()">
            <slot></slot>
        </v-list-item>
    </div>
</template>

<script>
    import EXCEL_DOWNLOAD from '@/utilities/services/downloads/excel/excelDownload';

    export default {
        name: "download-to-excel",
        props: ['jsonList', 'sheetName', 'fileTimeStamp', 'config', 'btnText', 'listItem'],
        data: () => ({
            configs: {
                downloadToolTip: {
                    i18n: 'participants.download'
                }
            }
        }),
        methods: {
            exportToExcel(){
                EXCEL_DOWNLOAD.exportJsonToSingleSheet(
                    this.jsonList,
                    this.sheetName,
                    this.fileTimeStamp,
                    this.config,
                );
            }
        },
    }
</script>

<style scoped>
    .downloadIconContainer{ position: absolute; right: 6px; top: 4px}
</style>